import { Component, h, Host, JSX, Prop } from "@stencil/core";

import { isString } from "../../../../shared/utility/helper";

@Component({
  tag: "phn-nd-heading",
  styleUrl: "heading.scss",
  scoped: true,
})
export class Heading {
  @Prop() text!: string;

  @Prop() subtext?: string;

  render(): JSX.Element {
    return (
      <Host>
        <phn-p-heading size="inherit">{this.text}</phn-p-heading>
        {isString(this.subtext) ? (
          <div class="text-limit fs-exclude" data-cs-mask>
            <phn-p-text
              color="contrast-high"
              size="xx-small"
              tag="div"
              ellipsis="true"
              align="center"
            >
              {this.subtext}
            </phn-p-text>
          </div>
        ) : null}
      </Host>
    );
  }
}
